// extracted by mini-css-extract-plugin
export default {"short_note":"Netzero_short_note__Jhk0Z","zoom":"Netzero_zoom__VBmK8","form":"Netzero_form__l-EAJ"};